import { useConnectionQualityIndicator } from "@livekit/components-react";
import type { ProviderLocalSignal } from "../types";
import { CONNECTION_QUALITY } from "./constants";
import { useLivekitLocalParticipant } from "./useLivekitLocalParticipant";

export const useLivekitLocalSignal = (): ProviderLocalSignal => {
  const localParticipant = useLivekitLocalParticipant();
  const { quality } = useConnectionQualityIndicator({
    participant: localParticipant,
  });
  return {
    localPeerDownlinkQuality: CONNECTION_QUALITY[quality],
  };
};
